/* eslint-disable prettier/prettier */
import { Message } from "../Utils/Message";
/**
 * DataGrid tooltip messages
 */
export const Messages = {
    EXPAND_ROW_GROUP: new Message("EXPAND_ROW_GROUP", "Expand Group"),
    COLLAPSE_ROW_GROUP: new Message("COLLAPSE_ROW_GROUP", "Collapse Group"),
    TOGGLE_EXPAND_ROW_GROUP: new Message("TOGGLE_EXPAND_ROW_GROUP", "Toggle Expand Grouped Rows"),
    YES: new Message("YES", "Yes"),
    NO: new Message("NO", "No")
};
